// src/App.js
import React, { useState } from "react";
import Room from "./Room";
import "./AppUI.css";

function App() {
    const [joined, setJoined] = useState(false);
    const [roomId, setRoomId] = useState(Math.round(Math.random()*100000));
    const [role, setRole] = useState("camera");

    const handleJoin = () => {
	
        if (!roomId) setRoomId(1);
        setJoined(true);
    };

    if (joined) {
        return <Room roomId={roomId} role={role} />;
    }
   
    return (
        <div className="app-container">
            <div className="card">
                <h2 className="title">⚡ The Power of iGOD</h2>

                <div className="input-group">
                    <label>Room</label>
                    <input type="text" value={roomId} onChange={(e) => setRoomId(e.target.value)}/>
                    {/*<select value={roomId} onChange={(e) => setRoomId(e.target.value)}>*/}
                    {/*    <option value="room1">Room 1</option>*/}
                    {/*    <option value="room2">Room 2</option>*/}
                    {/*    <option value="room3">Room 3</option>*/}
                    {/*    <option value="room4">Room 4</option>*/}
                    {/*    <option value="room5">Room 5</option>*/}
                    {/*    <option value="room6">Room 6</option>*/}
                    {/*    <option value="room7">Room 7</option>*/}
                    {/*    <option value="room8">Room 8</option>*/}
                    {/*    <option value="room9">Room 9</option>*/}
                    {/*    <option value="room10">Room 10</option>*/}
                    {/*</select>*/}
                </div>

                <div className="input-group">
                    <label>Role</label>
                    <select value={role} onChange={(e) => setRole(e.target.value)}>
                        <option value="camera">Camera + Mic</option>
                        <option value="screen">Screen Share</option>
                    </select>
                </div>

                <button className="join-btn" onClick={handleJoin}>
                    Join Room
                </button>
            </div>
        </div>
    );
}

export default App;
